import {getUserInfo} from "./author";
import {getLocalStorage} from "./storage";

/** A 版（截图上传页 /active）占比，0-100，改这个数字即可调比例 */
export const FOCUS_ACTIVITY_VARIANT_SPLIT = 50;

export type ActivityVariant = 'active' | 'active-b';

// FNV-1a 32bit 哈希：对同一字符串永远稳定
function fnv1a(str: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = (hash * 0x01000193) >>> 0;
  }
  return hash >>> 0;
}

/** 分流键：已登录用 userId，未登录用已持久化的 deviceId（不在此处生成） */
const getBucketKey = (): string => {
  const user = getUserInfo();
  if (user?.uuid) return user.uuid;
  return getLocalStorage('deviceId') || '';
};

/** 官方关注活动 AB 分流：返回命中的活动页变体 */
export const getActivityVariant = (): ActivityVariant => {
/*  const score = fnv1a(getBucketKey()) % 100;
  return score < FOCUS_ACTIVITY_VARIANT_SPLIT ? 'active' : 'active-b';*/
  return 'active-b';
};
